import { render, staticRenderFns } from "./TipoRede.vue?vue&type=template&id=c44f2722"
import script from "./TipoRede.vue?vue&type=script&lang=js"
export * from "./TipoRede.vue?vue&type=script&lang=js"
import style0 from "./TipoRede.vue?vue&type=style&index=0&id=c44f2722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports